export type AnytimeConsultationListTab = {
  id: number;
  key: string;
  title: string;
  department: number;
  complete: "0" | "1";
};

export type AnytimeConsultationListQuery = {
  tab_id?: string;
  department?: string;
  complete?: string;
};

export const ANYTIME_CONSULTATION_LIST_TABS: readonly AnytimeConsultationListTab[] = Object.freeze([
  { id: 0, key: "syounika_incomplete", title: "小児科未回答", department: 1, complete: "0" },
  { id: 1, key: "obstetrics_incomplete", title: "産婦人科未回答", department: 2, complete: "0" },
  { id: 2, key: "midwife_incomplete", title: "助産師未回答", department: 3, complete: "0" },
  { id: 3, key: "syounika_complete", title: "小児科回答済(48H)", department: 1, complete: "1" },
  { id: 4, key: "obstetrics_complete", title: "産婦人科回答済(48H)", department: 2, complete: "1" },
  { id: 5, key: "midwife_complete", title: "助産師回答済(48H)", department: 3, complete: "1" },
]);

export const findAnytimeConsultationListTab = (
  tabId: string | number | null | undefined
): AnytimeConsultationListTab | undefined => {
  if (tabId === null || tabId === undefined || tabId === "") return undefined;
  return ANYTIME_CONSULTATION_LIST_TABS.find((tab) => String(tab.id) === String(tabId));
};

// tab_id だけで一覧へ遷移すると、AnytimeConsultationHome が department / complete を補うために
// もう一度ルート遷移し、一覧の取得が重複・空振りする。最初から完全なクエリで遷移させるために使う
export const buildAnytimeConsultationListQuery = (
  tabId: string | number | null | undefined
): AnytimeConsultationListQuery => {
  const tab = findAnytimeConsultationListTab(tabId);
  if (!tab) {
    // 未知のタブは従来どおり tab_id のみ渡し、遷移先の判断は AnytimeConsultationHome に任せる
    return tabId === null || tabId === undefined ? {} : { tab_id: String(tabId) };
  }

  return {
    tab_id: String(tab.id),
    department: String(tab.department),
    complete: tab.complete,
  };
};
